import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Icon from '../ui/Icon';
import AppIcon from '../ui/AppIcon';
import WorkspaceIndicator from './WorkspaceIndicator';
import { installedApps } from '../registry/selectors';
import { activeTab } from './navConfig';
import './shell.css';

const PRIMARY = [
  { id: 'home', label: 'Home', icon: 'Home', path: '/' },
  { id: 'categories', label: 'Store', icon: 'LayoutGrid', path: '/store' },
  { id: 'my-apps', label: 'My Apps', icon: 'Layers', path: '/my-apps' },
  { id: 'updates', label: 'Updates', icon: 'Bell', path: '/updates' },
];

export default function HiveSidebar({ userInfo, logout }) {
  const history = useHistory();
  const location = useLocation();
  const active = activeTab(location.pathname);
  const routes = userInfo?.routes ? [...userInfo.routes] : [];
  const mine = installedApps(routes);
  const isMaster = routes.includes('app-control');

  const go = (path) => history.push(path);
  const appActive = (app) => location.pathname === app.path || location.pathname.startsWith(app.path + '/');

  return (
    <aside className="hive-sidebar hive-scroll">
      <WorkspaceIndicator userInfo={userInfo} variant="sidebar" />

      <nav className="hive-sidebar-nav">
        {PRIMARY.map((item) => (
          <button
            key={item.id}
            type="button"
            className={`hive-sidebar-item hive-tap${active === item.id ? ' is-active' : ''}`}
            onClick={() => go(item.path)}
          >
            <Icon name={item.icon} size={20} />
            <span>{item.label}</span>
          </button>
        ))}
      </nav>

      {mine.length > 0 && (
        <div className="hive-sidebar-section">
          <div className="hive-sidebar-heading">My Apps</div>
          {mine.map((app) => (
            <button
              key={app.id}
              type="button"
              className={`hive-sidebar-app hive-tap${appActive(app) ? ' is-active' : ''}`}
              onClick={() => go(app.path)}
            >
              <AppIcon app={app} size={26} radius={8} />
              <span>{app.name}</span>
            </button>
          ))}
        </div>
      )}

      <div className="hive-sidebar-foot">
        {isMaster && (
          <button
            type="button"
            className={`hive-sidebar-item hive-tap${location.pathname.startsWith('/admin') ? ' is-active' : ''}`}
            onClick={() => go('/admin/app-control')}
          >
            <Icon name="ShieldCheck" size={20} />
            <span>App Control</span>
          </button>
        )}
        <button type="button" className="hive-sidebar-item hive-tap" onClick={() => go('/more')}>
          <Icon name="Settings" size={20} />
          <span>Settings</span>
        </button>
        <button type="button" className="hive-sidebar-item hive-sidebar-danger hive-tap" onClick={logout}>
          <Icon name="LogOut" size={20} />
          <span>Log out</span>
        </button>
      </div>
    </aside>
  );
}
